const accountMenuStyle = (theme) => ({
	accountTitle: {
		backgroundColor: theme.palette.primary["200"],
	},
});

export default accountMenuStyle;
